<div class="hide-up-container">
    <div class="ng-hide-animate hide-up"
         [class.ng-hide-animate]="canAnimate"
         [class.ng-hide]="hidden">
        @if (data && data.promobarLines?.length) {
        <div class="w-12 pos-relative z-9"
             [class]="[
                data.paddingTop || 'p-t-2',
                data.paddingBottom || 'p-b-2',
                data.paddingLeft || 'p-l-8',
                data.paddingRight || 'p-r-8'
            ]"
             [style.background-color]="data.backgroundColor || '#333333'"
             [style.color]="data.fontColor || '#ffffff'">
            <div class="p2 flex-column flex-middle flex-justify-center pos-relative overflow-hidden"
                 [style.padding-top]="!data.paddingTop || data.paddingTop === 'p-t-2' ? '0.125em' : null">
                @if (data.animation === 'flowing_line') {
                <div class="_flowing-line"
                     [style.--animation-duration]="`${data.animationSpeed || 20}s`">
                    <div>
                        @for (line of data.promobarLines; track $index) {
                        <div class="flex flex-middle flex-justify-center">
                            <ng-container *ngTemplateOutlet="promobarLine; context: {$implicit: line}" />
                        </div>
                        }
                    </div>
                    <div>
                        @for (line of data.promobarLines; track $index) {
                        <div class="flex flex-middle flex-justify-center">
                            <ng-container *ngTemplateOutlet="promobarLine; context: {$implicit: line}" />
                        </div>
                        }
                    </div>
                </div>
                } @else if (data.animation === 'repeating_message') {
                <div class="_repeating-message"
                     [style.--animation-duration]="`${data.animationSpeed || 5}s`">
                    @for (i of [].constructor(20); track $index) {
                    <div class="_scrolling"
                         [attr.aria-hidden]="!$first">
                        @for (line of data.promobarLines; track $index) {
                        <ng-container *ngTemplateOutlet="promobarLine; context: {$implicit: line}" />
                        }
                        @if (data.showSeparator) {
                        <span class="p-l">&nbsp;•&nbsp;</span>
                        }
                    </div>
                    }
                </div>
                } @else if (data.animation === 'slider') {
                <fade-slider class="w-12"
                             [options]="{ interval : 5, pouseOnHover: true }">
                    @for (line of data.promobarLines; track $index) {
                    <fade-slider-slide class="center _slide">
                        <ng-container *ngTemplateOutlet="promobarLine; context: {$implicit: line}" />
                    </fade-slider-slide>
                    }
                </fade-slider>
                } @else {
                @for (line of data.promobarLines; track $index) {
                <div class="flex flex-middle"
                     [class.m-t-1]="!$first">
                    <div class="h-100 flex flex-middle flex-justify-center">
                        <ng-container *ngTemplateOutlet="promobarLine; context: {$implicit: line}" />
                    </div>
                </div>
                }
                }
            </div>
        </div>
        <!-- close -->
        @if (data.closeable) {
        <button class="pos-absolute top-50 right-5 right-1-s z-10 p-a-1 flex flex-middle flex-justify-center cursor-pointer"
                [style.color]="data.fontColor || '#ffffff'"
                type="button"
                [attr.aria-label]="'Close' | translate"
                (click)="hide()">
            <i class="icon-close"
               aria-hidden="true"></i>
        </button>
        }
        }
        <!-- line template -->
        <ng-template #promobarLine
                     let-line>
            <!-- line item -->
            @for (item of line.lineItems; track $index) {
            <!-- space between items -->
            @if (!$first || ($first && data.animation === 'repeating_message')) {
            &nbsp;
            }
            @switch (item.item_type) {
            <!-- text/link -->
            @case ('text_or_link') {
            <href [link]="item.link"
                  [hrefClass]="item.link_style">
                <span [gtmTrackClick]="{category: 'MegaNav', action: 'MegaNav Promo', label: 'MegaNav Promo ' + item.link}"
                      [class.underline]="item.underline"
                      [class.fw-bold]="item.bold">
                    {{item.text}}
                </span>
            </href>
            }
            <!-- countdown -->
            @case ('countdown') {
            <countdown [date]="item.end_date"
                       [shouldPad]="true">
                <ng-template #countdownTemplate
                             let-result>
                    @if (result.score?.seconds) {
                    <!-- result / X, L, M -->
                    @if (!client.isS) {
                    @if (result.score?.days) { {{result.score?.days}}d }
                    {{result.score?.hours}}h {{result.score?.minutes}}m {{result.score?.seconds}}s
                    } @else {
                    @if (result.score?.days) { {{result.score?.days}}: }
                    {{result.score?.hours}}:{{result.score?.minutes}}:{{result.score?.seconds}}
                    }
                    }
                </ng-template>
            </countdown>
            }
            <!-- separator-->
            @case ('separator') {
            —
            }
            <!-- additional space -->
            @case ('space') {
            &nbsp;
            }
            }
            }
        </ng-template>
    </div>
</div>